import { render, staticRenderFns } from "./TeachingForm.vue?vue&type=template&id=64e360a0&scoped=true&"
import script from "./TeachingForm.vue?vue&type=script&lang=js&"
export * from "./TeachingForm.vue?vue&type=script&lang=js&"
import style0 from "./TeachingForm.vue?vue&type=style&index=0&id=64e360a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e360a0",
  null
  
)

export default component.exports